import { type FC, useEffect } from "react";
import { Navigate } from "react-router";

import { useAuth } from "@/hooks/auth";

const Logout: FC = () => {
  const { user, signOut } = useAuth();

  useEffect(() => {
    signOut();
  }, [signOut]);

  // signOut clears the user synchronously, so the redirect falls out of the
  // next render rather than out of a second piece of state.
  if (user) {
    return null;
  }
  return <Navigate to="/login" />;
};

export default Logout;
